import contractRoutes from './contract.route';
import servicesMonthCertificationRoutes from './services-month-certification.route';
import contractDocumentConfigurationRoutes from './contract-document-configuration.route';
import specialistManagementRoutes from './specialist-management.route';
import endTermRoutes from './end-term.route';
import billingRoutes from './billing.route';
import locationServiceManagementRoutes from './location-service-management.route';
import providerRoutes from './provider.route';
import aeeQuestionnaireRoutes from './aee-questionnaire-management.route';
import servicesCompensatoryManagementRoute from './services-compensatory-management.route';

const routes = [
  {
    path: 'provider',
    component: () => import('@/views/provider/ProviderWrapper.vue'),
    children: [
      {
        path: '/provider/menu',
        name: 'provider',
        component: () => import('@/views/provider/Menu.vue'),
      },
      contractRoutes,
      servicesMonthCertificationRoutes,
      contractDocumentConfigurationRoutes,
      specialistManagementRoutes,
      endTermRoutes,
      billingRoutes,
      locationServiceManagementRoutes,
      providerRoutes,
      aeeQuestionnaireRoutes,
      servicesCompensatoryManagementRoute,
    ],
  },
];

export default routes;
